import {
  queryList,
  queryNewAction,
  queryAddConfigAction,
  queryItemConfigAction,
  queryListInformation,
  querySaveInformation,
  queryListPermissions,
  querySavePermission,
  querySaveConfigList,
  generateIA,
  querySaveInformationCondition,
  queryActionsDiagramByToken,
  updateActionsDiagramPositions,
  updateNotesDiagramPositions,
  updateNoteDiagramPosition,
  appendActionToDiagram,
  appendNoteToDiagram,
  modifyNoteDiagram,
  setNextAction,
  removeActionFromDiagram,
  removeNoteDiagram,
  modifyActionConfig,
} from './service';
import { CoreEnums } from '@/utils/domain/constants';
import { generateActionConfigFromEnum } from './utils/actionConfigGenerator';

import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  newAction: false,
  selectedItem: null,
  configSelectedItem: null,
  formConfig: null,
  showConfig: false,
  list: [],
  listConfig: [],
  dataInfomation: null,
  listAll: [],
  actionPermission: null,
  pagination: meta,
  view: false,
  orderBy: '',
  id: null,
  loadingItem: false,
  type: null,
  drawer: false,
  success: false,
  tab: '',
  activeActionId: null, // Track currently open action for token refresh
  notes: [], // Store diagram notes from server
  autoBeautify: false, // Flag to trigger automatic layout when diagram positions are missing
  ListTab: null,
  tabs: [
    {
      name: 'configurations',
      drawer: false, // Direct form, not a CardList drawer
    },
    {
      name: 'approval',
      type: [1, 2, 5, 8], // CompleteInformation, Approval, ExecuteTask, DigitalSignature
      drawer: true,
    },
    // Approval sub-tabs (first level - parent: 'approval')
    {
      name: 'action-approval-general',
      type: [1, 2, 5, 8],
      parent: 'approval',
    },
    {
      name: 'action-approval-rejection',
      type: [1, 2, 8], // Only for CompleteInformation, Approval, DigitalSignature
      parent: 'approval',
    },
    {
      name: 'action-approval-deadline',
      type: [1, 2, 5, 8],
      parent: 'approval',
    },
    {
      name: 'action-approval-filters',
      type: [1, 2, 5, 8],
      drawer: true, // This will show another CardList with filter options
      parent: 'approval',
    },
    // Approval Filters sub-tabs (second level - parent: 'action-approval-filters')
    {
      name: 'action-approval-filters-general',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-users',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-positions',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-areas',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-user-groups',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-external-users',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-agents',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-user-extra-fields',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-global-approvers',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'action-approval-filters-form-field-user-approvers',
      type: [1, 2, 5, 8],
      parent: 'action-approval-filters',
    },
    {
      name: 'custom-notifications',
      field: 'isNotificationsEnabled',
      type: [1, 2],
    },
    {
      name: 'notifications-mapping-attachments',
      field: 'isNotificationsEnabled',
      type: [1, 2],
    },
    {
      name: 'email-template',
      field: 'isNotificationsEnabled',
      type: [1, 2],
    },
    {
      name: 'pdf-template-generation-mapping',
      field: 'isPDFGenerationEnabled',
      type: [1, 2],
    },
    {
      name: 'conditional',
      type: [4],
    },
    {
      name: 'form-complete-information',
      type: [1],
    },
    {
      name: 'webhook-mapping',
      field: 'isWebhookEnabled',
      all: true,
    },
    {
      name: 'digital-signature-field-mapping',
      type: [6],
      all: true,
    },
    {
      name: 'response-status',
      type: [6],
      all: true,
    },
    {
      name: 'api-call-send',
      type: [6],
      all: true,
    },
    {
      name: 'api-call-response',
      type: [6],
      all: true,
    },
    {
      name: 'set-variable',
      type: [14],
      all: true,
    },
    {
      name: 'action-entity-operation',
      type: [11], // DynamicEntityOperation
    },
    {
      name: 'action-scheduled-execution',
      type: [18], // ScheduledExecution
    },
  ],
  history: [],
  currentIndex: -1,
  latestSaveIndex: -1,
  generateIA: {},
  defaultFieldsValue: null,
};

const Model = {
  namespace: 'processActionConfig',

  state: initialState,

  effects: {
    *initializeActionsConfig({ payload }, { put }) {
      try {
        // Initialize action configuration list from ActionType enum
        const { formatMessage } = payload;
        const actionConfigs = generateActionConfigFromEnum(formatMessage);
        yield put({
          type: 'queryActionsConfig',
          payload: actionConfigs,
        });
      } catch (error) {
        /* silent */
      }
    },
    *fetchDiagramByToken({ payload }, { call, put }) {
      try {
        const response = yield call(queryActionsDiagramByToken, payload);
        const actions = Array.isArray(response?.actions) ? response.actions : [];
        const shouldBeautify =
          actions.length > 0 &&
          actions.every((action) => {
            const diagramData = action?.diagramData;
            if (!diagramData) {
              return true;
            }
            const hasX = !_.isNil(diagramData.x) || !_.isNil(diagramData.xCoordinate);
            const hasY = !_.isNil(diagramData.y) || !_.isNil(diagramData.yCoordinate);
            return !(hasX || hasY);
          });
        yield put({
          type: 'queryActionsFromDiagram',
          payload: response,
        });
        yield put({
          type: 'setAutoBeautify',
          payload: shouldBeautify,
        });
      } catch (error) {
        /* silent */
      }
    },

    *updateDiagramPositions({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, positions } = payload;

        // Transform positions to the required format
        const diagramData = positions.map((position) => ({
          id: position.id,
          diagramData: {
            x: position.x,
            y: position.y,
            collapsed: true, // Always true as specified
          },
        }));

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          yield call(updateActionsDiagramPositions, {
            processId,
            versionId,
            token,
            data: diagramData,
          });

          // After successful PATCH, update local state to maintain sync
          yield put({
            type: 'updateLocalPositions',
            payload: positions,
          });
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *updateDiagramPositionsAndRefresh({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, positions } = payload;

        // Transform positions to the required format
        const diagramData = positions.map((position) => ({
          id: position.id,
          diagramData: {
            x: position.x,
            y: position.y,
            collapsed: true, // Always true as specified
          },
        }));

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          // Send PATCH request
          yield call(updateActionsDiagramPositions, {
            processId,
            versionId,
            token,
            data: diagramData,
          });

          // After successful PATCH, refresh diagram from server to ensure consistency
          yield new Promise((resolve) => setTimeout(resolve, 200)); // Slightly longer delay for beautify

          const diagramResponse = yield call(queryActionsDiagramByToken, {
            token: token,
            versionId: versionId,
            processId: processId,
          });

          yield put({
            type: 'queryActionsFromDiagram',
            payload: diagramResponse,
          });
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *updateNotesDiagramPositions({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, positions } = payload;

        // Transform positions to diagram data format
        const diagramData = positions.map(({ id, x, y }) => ({
          id,
          diagramData: {
            x: x,
            y: y,
          },
        }));

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          yield call(updateNotesDiagramPositions, {
            processId,
            versionId,
            token,
            data: diagramData,
          });

          // After successful PATCH, update local state to maintain sync
          yield put({
            type: 'updateLocalNotePositions',
            payload: positions,
          });
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *updateNoteDiagramPosition({ payload }, { call, select }) {
      try {
        const { processId, versionId, token, noteId, position } = payload;

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          yield call(updateNoteDiagramPosition, {
            processId,
            versionId,
            token,
            noteId,
            data: {
              diagramData: {
                x: position.x,
                y: position.y,
              },
            },
          });
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *updateNoteContent({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, noteId, text, position } = payload;

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          const requestData = {
            elementType: 'note',
            itemId: noteId,
            data: {
              notes: text,
              diagramData: {
                x: position.x,
                y: position.y,
              },
            },
          };

          const response = yield call(modifyNoteDiagram, {
            processId,
            versionId,
            token,
            data: requestData,
          });

          // If successful, refresh the diagram to get the updated data
          if (response && (response.data || response.success !== false)) {
            const diagramResponse = yield call(queryActionsDiagramByToken, {
              processId,
              versionId,
              token,
            });

            if (diagramResponse) {
              yield put({
                type: 'queryActionsFromDiagram',
                payload: diagramResponse,
              });
            }
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *deleteNoteDiagram({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, noteId } = payload;

        // Only delete if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          const requestData = {
            elementType: 'note',
            itemId: noteId,
            force: true,
          };

          const response = yield call(removeNoteDiagram, {
            processId,
            versionId,
            token,
            data: requestData,
          });

          // If successful, remove the note from local state (optimistic update)
          if (response !== null && response !== undefined) {
            yield put({
              type: 'removeNoteFromList',
              payload: { noteId },
            });
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *appendActionToDiagram({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, actionType, position, name } = payload;

        // Only append if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          const requestData = {
            elementType: 'action',
            data: {
              enabled: true,
              type: actionType,
              name: name || `Nueva ${actionType}`,
              diagramData: {
                x: position.x,
                y: position.y,
              },
            },
          };

          const response = yield call(appendActionToDiagram, {
            processId,
            versionId,
            token,
            data: requestData,
          });

          // If successful, add the new action to the list optimistically
          if (response && response.newItemId) {
            yield put({
              type: 'addServerActionToList',
              payload: response.data,
            });
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *appendNoteToDiagram({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, position, text } = payload;

        // Only append if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          // Generate a temporary GUID for the new note
          const tempId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          });

          const requestData = {
            elementType: 'note',
            itemId: tempId.toUpperCase(),
            data: {
              notes: text || '',
              diagramData: {
                x: position.x,
                y: position.y,
              },
            },
          };

          const response = yield call(appendNoteToDiagram, {
            processId,
            versionId,
            token,
            data: requestData,
          });

          // If successful, refresh the diagram to get the updated data
          if (response && (response.newItemId || response.data)) {
            // Query the diagram again to get the complete updated data
            const diagramResponse = yield call(queryActionsDiagramByToken, {
              processId,
              versionId,
              token,
            });

            if (diagramResponse) {
              yield put({
                type: 'queryActionsFromDiagram',
                payload: diagramResponse,
              });
            }
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *setNextAction({ payload }, { call, select, put }) {
      try {
        const {
          processId,
          versionId,
          token,
          fromActionId,
          toActionId,
          isFalseConnection,
        } = payload;

        // Only update if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          // Get the target action data
          const currentState = yield select((state) => state.processActionConfig);
          const toAction = currentState.list.find((action) => action.id === toActionId);

          if (toAction) {
            // Map enum type back to string using ActionTypeString
            const actionTypeKey = Object.keys(CoreEnums.ActionType).find(
              (key) => CoreEnums.ActionType[key] === toAction.type,
            );
            const typeString = actionTypeKey
              ? CoreEnums.ActionTypeString[actionTypeKey]
              : 'complete-information';

            const requestData = {
              nextAction: {
                id: toAction.id,
                name: toAction.name || toAction.displayTitle,
                type: typeString,
              },
            };

            // Send PATCH to server
            yield call(setNextAction, {
              processId,
              versionId,
              token,
              actionId: fromActionId,
              data: requestData,
            });

            // Update local state to reflect the connection immediately
            const updatedList = currentState.list.map((action) => {
              if (action.id === fromActionId) {
                // Update the appropriate connection field based on connection type
                if (isFalseConnection) {
                  return {
                    ...action,
                    nextActionIfFalseId: toActionId,
                  };
                } else {
                  return {
                    ...action,
                    nextActionId: toActionId,
                  };
                }
              }
              return action;
            });

            yield put({
              type: 'updateConnectionInList',
              payload: updatedList,
            });
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },

    *removeActionFromDiagram({ payload }, { call, select, put }) {
      try {
        const { processId, versionId, token, actionId } = payload;

        // Only remove if we're in Write mode
        const processConfigState = yield select((state) => state.processConfig);
        const isWriteMode = processConfigState.accessMode === CoreEnums.AccessMode.Write;

        if (isWriteMode) {
          const requestData = {
            elementType: CoreEnums.BuilderElementType.Action,
            itemId: actionId,
            force: true,
          };

          const response = yield call(removeActionFromDiagram, {
            processId,
            versionId,
            token,
            data: requestData,
          });

          // If successful, remove the action from local state
          if (response !== null && response !== undefined) {
            yield put({
              type: 'removeActionFromList',
              payload: { actionId },
            });
          }
        }
      } catch (error) {
        // Silent fail to avoid leaking sensitive data
      }
    },
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryActions',
          payload: response,
        });
      } catch (error) {
        /*  */
      }
    },
    *fetchGenerateIA({ payload }, { call, put }) {
      try {
        const response = yield call(generateIA, payload);
        yield put({
          type: 'queryGenerateIA',
          payload: response,
        });
      } catch (error) {
        /*  */
      }
    },

    *initAddHistory({ put }, { payload }) {
      yield put({ type: 'addState', payload });
    },

    *fetchSaveConfigList({ payload }, { call, put, select }) {
      try {
        const history = yield select((state) => state.processActionConfig.history);
        const data = history[history.length - 1]
          ?.filter((l) => l.updated === true && !l.id.startsWith('action_'))
          .map((l) => ({
            id: l.id,
            nextActionId: l.nextActionId,
            ...(l.nextActionIfFalseId && { nextActionIfFalseId: l.nextActionIfFalseId }),
            diagramData: {
              xCoordinate: l.x,
              yCoordinate: l.y,
            },
          }));
        if (data.length === 0) return;
        const response = yield call(querySaveConfigList, { ...payload, data });
      } catch (error) {
        /*  */
      }
    },
    *getItemConfigAction({ payload }, { call, put, select }) {
      try {
        // Prefer payload values, fallback to store
        const storeGeneratedToken = yield select((s) => s.processConfig.generatedToken);
        const storeProcessId = yield select((s) => s.processConfig.processId);
        const processId = payload.processId ?? storeProcessId;
        const versionId = payload.versionId ?? storeGeneratedToken?.versionId;
        const token = payload.token ?? storeGeneratedToken?.token;

        if (!processId || !versionId || !token || !payload.id) {
          return;
        }

        const response = yield call(queryItemConfigAction, {
          processId,
          versionId,
          token,
          id: payload.id,
        });
        // Set data for tabs visibility and for configuration form
        yield put({ type: 'queryItemActionsList', payload: response });
        yield put({ type: 'queryItemActionsConfig', payload: response });
        yield put({ type: 'activeTabs', payload: 'configurations' });
      } catch (error) {
        /*  */
      }
    },

    *fetchListInformation({ payload }, { call, put }) {
      try {
        const response = yield call(queryListInformation, payload);
        yield put({
          type: 'queryInformation',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *fetchListCondition({ payload }, { call, put }) {
      try {
        const response = yield call(queryListInformation, payload);
        yield put({
          type: 'queryCondiion',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield call(querySavePermission, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSuccessPermission',
          payload: {
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *saveInformation({ payload }, { call, put }) {
      try {
        yield call(querySaveInformation, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addInformation',
          payload: {
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
    *querySaveInformationCondition({ payload }, { call, put }) {
      try {
        yield call(querySaveInformationCondition, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addInformation',
          payload: {
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *addNewAction({ payload }, { put }) {
      yield put({
        type: 'addAction',
        payload: {
          ...payload,
        },
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewAction',
          payload,
        });
      }
    },

    *saveNewAction({ payload }, { call, put }) {
      try {
        const response = yield call(queryNewAction, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveAction',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveNewActionBySteps({ payload }, { call, put }) {
      try {
        const response = yield call(queryNewAction, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        _.isFunction(payload.onFinish) && payload.onFinish(response);
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveConfigAction({ payload }, { call, put }) {
      try {
        // Use the new modify endpoint if builder tokens are provided
        let response;
        if (payload.processId && payload.versionId && payload.token) {
          response = yield call(modifyActionConfig, {
            processId: payload.processId,
            versionId: payload.versionId,
            token: payload.token,
            data: payload.data,
          });
        } else {
          // Fallback to old endpoint for backward compatibility
          response = yield call(queryAddConfigAction, payload.data);
        }

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveAction',
          payload: response,
        });

        // Only fetch list if NOT in builder context
        if (!payload.processId || !payload.versionId || !payload.token) {
          yield put({
            type: 'fetchList',
            payload: payload.params,
          });
        } else {
          // In builder context, refresh the diagram instead
          yield put({
            type: 'fetchDiagramByToken',
            payload: {
              processId: payload.processId,
              versionId: payload.versionId,
              token: payload.token,
            },
          });
        }
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *searchCriteria({ payload }, { put }) {
      try {
        yield put({
          type: 'searchCriterias',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },

    *updateNode({ payload }, { put }) {
      try {
        yield put({
          type: 'updateNodes',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *showConfigAction({ payload }, { put }) {
      try {
        yield put({
          type: 'showConfigActions',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },

    *updateNextActionId({ payload }, { put }) {
      try {
        yield put({
          type: 'updateNextActionIds',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },

    *activeTab({ payload }, { put }) {
      yield put({ type: 'activeTabs', payload });
    },
    *clearSelectedItem({ payload }, { put }) {
      yield put({ type: 'clearSelectedItems', payload });
    },

    *hideAllActions({ payload = 'hideActions' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    resetConfig(state) {
      return {
        ...initialState,
      };
    },

    clearActiveAction(state) {
      return {
        ...state,
        activeActionId: null,
        selectedItem: null,
      };
    },

    queryActionsFromDiagram(state, { payload }) {
      // payload now comes as an object with { actions: [...], notes: [...] }
      const typeMap = {
        'default-initial': CoreEnums.ActionType.DefaultInitial,
        'complete-information': CoreEnums.ActionType.CompleteInformation,
        approval: CoreEnums.ActionType.Approval,
        'auto-approve': CoreEnums.ActionType.AutoApprove,
        conditional: CoreEnums.ActionType.Conditional,
        'execute-task': CoreEnums.ActionType.ExecuteTask,
        'execute-api-call': CoreEnums.ActionType.ExecuteApiCall,
        'auto-reject': CoreEnums.ActionType.AutoReject,
        'digital-signature': CoreEnums.ActionType.DigitalSignature,
        'send-email': CoreEnums.ActionType.SendEmail,
        'execute-query': CoreEnums.ActionType.ExecuteQuery,
        'dynamic-entity-operation': CoreEnums.ActionType.DynamicEntityOperation,
        'generate-excel': CoreEnums.ActionType.GenerateExcel,
        'start-process-instance': CoreEnums.ActionType.StartProcessInstance,
        'set-variable': CoreEnums.ActionType.SetVariableData,
        'set-form-data': CoreEnums.ActionType.SetFormData,
        parallel: CoreEnums.ActionType.Parallel,
        'generate-documents': CoreEnums.ActionType.GenerateDocuments,
        'scheduled-execution': CoreEnums.ActionType.ScheduledExecution,
        'sharepoint-operation': CoreEnums.ActionType.SharePointOperation,
        iterate: CoreEnums.ActionType.Iterate,
        switch: CoreEnums.ActionType.Switch,
        'internal-operation': CoreEnums.ActionType.InternalOperation,
        'generate-plain-text-file': CoreEnums.ActionType.GeneratePlainTextFile,
        'import-plain-text-file': CoreEnums.ActionType.ImportPlainTextFile,
        'consume-sequence': CoreEnums.ActionType.ConsumeSequence,
        'execute-rpa-flow': CoreEnums.ActionType.ExecuteRpaFlow,
        integration: CoreEnums.ActionType.Integration,
        'auto-cancel': CoreEnums.ActionType.AutoCancel,
        'auto-void': CoreEnums.ActionType.AutoVoid,
        openai: CoreEnums.ActionType.OpenAI,
        'automy-ai': CoreEnums.ActionType.AutomyAI,
        'execute-process-action': CoreEnums.ActionType.ExecuteProcessAction,
        'google-integration': CoreEnums.ActionType.GoogleIntegration,
        'revert-cancellation': CoreEnums.ActionType.RevertCancellation,
        'revert-voiding': CoreEnums.ActionType.RevertVoiding,
        'ftp-operation': CoreEnums.ActionType.FTPOperation,
        'run-code': CoreEnums.ActionType.RunCode,
        'whatsapp-business-integration': CoreEnums.ActionType.WhatsAppBusinessIntegration,
      };

      // Extract actions array from payload object
      const actionsArray = payload?.actions || payload || [];
      const list = actionsArray.map((a) => {
        const type = typeMap[a.type] ?? CoreEnums.ActionType.CompleteInformation;
        const x =
          a.diagramData?.x ??
          a.diagramData?.xCoordinate ??
          (a.enabled ? Math.floor(Math.random() * 1400) + 50 : 0);
        const y =
          a.diagramData?.y ??
          a.diagramData?.yCoordinate ??
          (a.enabled ? Math.floor(Math.random() * 800) + 50 : 0);
        return {
          ...a,
          type,
          displayTitle: a.name || a.description || 'Sin nombre', // Generate displayTitle from name
          diagramData: { x, y },
          nextActionId: a.nextAction?.id,
          nextActionIfFalseId: a.nextActionIfFalse?.id,
          // Add legacy properties for compatibility
          isDefaultInternalInitialCompleteInformationAction: a.type === 'default-initial',
          isInitialAction: a.type === 'default-initial',
        };
      });

      // Force a new array reference for notes to ensure React detects changes
      const notesArray = payload?.notes || [];
      const notes = [...notesArray];

      return {
        ...state,
        list,
        notes, // Store notes from diagram response with new array reference
      };
    },
    setAutoBeautify(state, { payload }) {
      return {
        ...state,
        autoBeautify: !!payload,
      };
    },
    queryActions(state, { payload }) {
      const data = payload.items || [];
      return {
        ...state,
        list: _.map(data, (l, key) => {
          return {
            ...l,
            diagramData: {
              x: l.isDefaultInternalInitialCompleteInformationAction
                ? 0
                : l.diagramData?.x ??
                  l.diagramData?.xCoordinate ??
                  Math.floor(Math.random() * (1500 - 50 + 1)) + 50,
              y: l.isDefaultInternalInitialCompleteInformationAction
                ? 0
                : l.diagramData?.y ??
                  l.diagramData?.yCoordinate ??
                  Math.floor(Math.random() * (1500 - 50 + 1)) + 50,
            },
          };
        }),
      };
    },
    queryGenerateIA(state, { payload }) {
      const data = payload.items || [];
      return {
        ...state,
        queryGenerateIA: {
          ...payload,
          actions: _.map(payload.actions, (l, key) => {
            return {
              ...l,
              diagramData: {
                x: l.isDefaultInternalInitialCompleteInformationAction
                  ? 0
                  : l.diagramData?.xCoordinate || Math.floor(Math.random() * (1500 - 50 + 1)) + 50,
                y: l.isDefaultInternalInitialCompleteInformationAction
                  ? 0
                  : l.diagramData?.yCoordinate || Math.floor(Math.random() * (1500 - 50 + 1)) + 50,
              },
            };
          }),
        },
      };
    },
    updateNodes(state, { payload, item, cords }) {
      return {
        ...state,
        list: _.map(state.list, (l) => {
          if (l.id === payload.item.id) {
            return {
              ...l,
              cords: payload.cords,
            };
          }
          return l;
        }),
      };
    },
    queryActionsConfig(state, { payload }) {
      return {
        ...state,
        listConfig: payload,
        listAll: payload,
      };
    },
    queryItemActionsList(state, { payload }) {
      // Map string type to numeric using ActionTypeString
      let mappedType = payload.type;
      if (typeof payload.type === 'string') {
        const actionTypeKey = Object.keys(CoreEnums.ActionTypeString).find(
          (key) => CoreEnums.ActionTypeString[key] === payload.type,
        );
        mappedType = actionTypeKey ? CoreEnums.ActionType[actionTypeKey] : payload.type;
      }

      const mapped = {
        ...payload,
        type: mappedType,
        // Map backend field names to frontend form field names
        ...(payload.hasOwnProperty('enabled') && { isActive: payload.enabled }),
        ...(payload.form && {
          completeInformationFormId:
            typeof payload.form === 'object'
              ? { label: payload.form.name, value: payload.form.id, ...payload.form }
              : payload.form,
        }),
        ...(payload.nextAction && {
          nextActionId:
            typeof payload.nextAction === 'object'
              ? {
                  label: payload.nextAction.name,
                  value: payload.nextAction.id,
                  ...payload.nextAction,
                }
              : payload.nextAction,
        }),
        ...(payload.hasOwnProperty('autoOpenEditOperation') && {
          isAutoOpenEditOperationEnabled: payload.autoOpenEditOperation,
        }),
        ...(payload.hasOwnProperty('disableComplete') && {
          isCompletedOptionDisabled: payload.disableComplete,
        }),
        ...(payload.hasOwnProperty('hideSaveButton') && {
          saveButtonDisabled: payload.hideSaveButton,
        }),
        ...(payload.allowedApplication && {
          allowedAppClientId:
            typeof payload.allowedApplication === 'object'
              ? {
                  label: payload.allowedApplication.applicationName,
                  value: payload.allowedApplication.id,
                  ...payload.allowedApplication,
                }
              : payload.allowedApplication,
        }),
        ...(payload.hasOwnProperty('allowedInternalExecution') && {
          isInternalExecutionAllowed: payload.allowedInternalExecution,
        }),
        ...(payload.nextActionIfFalse && {
          nextActionIfFalseId:
            typeof payload.nextActionIfFalse === 'object'
              ? {
                  label: payload.nextActionIfFalse.name,
                  value: payload.nextActionIfFalse.id,
                  ...payload.nextActionIfFalse,
                }
              : payload.nextActionIfFalse,
        }),
        ...(payload.connection && {
          connectionId:
            typeof payload.connection === 'object'
              ? {
                  label: payload.connection.name,
                  value: payload.connection.id,
                  ...payload.connection,
                }
              : payload.connection,
        }),
        ...(payload.process && {
          processId:
            typeof payload.process === 'object'
              ? { label: payload.process.name, value: payload.process.id, ...payload.process }
              : payload.process,
        }),
        ...(payload.actionToExecute && {
          actionToExecuteId:
            typeof payload.actionToExecute === 'object'
              ? {
                  label: payload.actionToExecute.name,
                  value: payload.actionToExecute.id,
                  ...payload.actionToExecute,
                }
              : payload.actionToExecute,
        }),
        ...(payload.sequence && {
          sequenceId:
            typeof payload.sequence === 'object'
              ? { label: payload.sequence.name, value: payload.sequence.id, ...payload.sequence }
              : payload.sequence,
        }),
        ...(payload.rpaAgent && {
          rpaAgentId:
            typeof payload.rpaAgent === 'object'
              ? { label: payload.rpaAgent.name, value: payload.rpaAgent.id, ...payload.rpaAgent }
              : payload.rpaAgent,
        }),
        ...(payload.rpaFlow && {
          rpaFlowId:
            typeof payload.rpaFlow === 'object'
              ? { label: payload.rpaFlow.name, value: payload.rpaFlow.id, ...payload.rpaFlow }
              : payload.rpaFlow,
        }),
        ...(payload.integration && {
          integrationId:
            typeof payload.integration === 'object'
              ? {
                  label: payload.integration.name,
                  value: payload.integration.id,
                  ...payload.integration,
                }
              : payload.integration,
        }),
        ...(payload.integrationFunction && {
          integrationFunctionId:
            typeof payload.integrationFunction === 'object'
              ? {
                  label: payload.integrationFunction.name,
                  value: payload.integrationFunction.id,
                  ...payload.integrationFunction,
                }
              : payload.integrationFunction,
        }),
        // Note: dynamicEntity, operation, searchResultGroupingMode, searchResultAllocationMode, sortField, sortDirection, itemsAffected, customItemsAffectedNumber
        // are handled in the separate action-entity-operation component, not in the main config form

        // reason, logicalOperator, operationType, model, serviceType, sharePointOperation, ftpOperationType, programmingLanguage, whatsAppBusinessOperationType are mapped directly (no transformation needed)
      };

      return {
        ...state,
        selectedItem: mapped,
        activeActionId: mapped.id, // Track the active action ID for token refresh
        ListTab: _.filter(state.tabs, (l) => {
          const isTypeMatch = _.includes(l.type, mapped.type);

          const hasFieldValue = !l.field || (l.field && mapped[l.field]);

          return l.name === 'configurations' || (isTypeMatch && hasFieldValue);
        }),
      };
    },

    queryItemActionsConfig(state, { payload }) {
      // If payload has a string type, convert it to numeric
      // Also map backend field names to frontend form field names
      let normalizedPayload = payload;

      if (payload) {
        normalizedPayload = { ...payload };

        // Map string type to numeric using ActionTypeString
        if (typeof payload.type === 'string') {
          const actionTypeKey = Object.keys(CoreEnums.ActionTypeString).find(
            (key) => CoreEnums.ActionTypeString[key] === payload.type,
          );
          normalizedPayload.type = actionTypeKey
            ? CoreEnums.ActionType[actionTypeKey]
            : payload.type;
        }

        // Map backend field names to frontend form field names
        if (payload.hasOwnProperty('enabled')) {
          normalizedPayload.isActive = payload.enabled;
        }

        // Map form object to formId (keep full object for selector display)
        if (payload.form) {
          normalizedPayload.completeInformationFormId =
            typeof payload.form === 'object'
              ? { label: payload.form.name, value: payload.form.id, ...payload.form }
              : payload.form;
        }

        // Map nextAction object to nextActionId (keep full object for selector display)
        if (payload.nextAction) {
          normalizedPayload.nextActionId =
            typeof payload.nextAction === 'object'
              ? {
                  label: payload.nextAction.name,
                  value: payload.nextAction.id,
                  ...payload.nextAction,
                }
              : payload.nextAction;
        }

        // Map autoOpenEditOperation to isAutoOpenEditOperationEnabled
        if (payload.hasOwnProperty('autoOpenEditOperation')) {
          normalizedPayload.isAutoOpenEditOperationEnabled = payload.autoOpenEditOperation;
        }

        // Map disableComplete to isCompletedOptionDisabled
        if (payload.hasOwnProperty('disableComplete')) {
          normalizedPayload.isCompletedOptionDisabled = payload.disableComplete;
        }

        // Map hideSaveButton to saveButtonDisabled
        if (payload.hasOwnProperty('hideSaveButton')) {
          normalizedPayload.saveButtonDisabled = payload.hideSaveButton;
        }

        // Map allowedApplication object to allowedAppClientId (keep full object for selector display)
        if (payload.allowedApplication) {
          normalizedPayload.allowedAppClientId =
            typeof payload.allowedApplication === 'object'
              ? {
                  label: payload.allowedApplication.applicationName,
                  value: payload.allowedApplication.id,
                  ...payload.allowedApplication,
                }
              : payload.allowedApplication;
        }

        // Map allowedInternalExecution to isInternalExecutionAllowed
        if (payload.hasOwnProperty('allowedInternalExecution')) {
          normalizedPayload.isInternalExecutionAllowed = payload.allowedInternalExecution;
        }

        // Map nextActionIfFalse object to nextActionIfFalseId (keep full object for selector display)
        if (payload.nextActionIfFalse) {
          normalizedPayload.nextActionIfFalseId =
            typeof payload.nextActionIfFalse === 'object'
              ? {
                  label: payload.nextActionIfFalse.name,
                  value: payload.nextActionIfFalse.id,
                  ...payload.nextActionIfFalse,
                }
              : payload.nextActionIfFalse;
        }

        // Map connection object to connectionId (keep full object for selector display)
        if (payload.connection) {
          normalizedPayload.connectionId =
            typeof payload.connection === 'object'
              ? {
                  label: payload.connection.name,
                  value: payload.connection.id,
                  ...payload.connection,
                }
              : payload.connection;
        }

        // Map process object to processId
        if (payload.process) {
          normalizedPayload.processId =
            typeof payload.process === 'object'
              ? { label: payload.process.name, value: payload.process.id, ...payload.process }
              : payload.process;
        }

        // Map actionToExecute object to actionToExecuteId
        if (payload.actionToExecute) {
          normalizedPayload.actionToExecuteId =
            typeof payload.actionToExecute === 'object'
              ? {
                  label: payload.actionToExecute.name,
                  value: payload.actionToExecute.id,
                  ...payload.actionToExecute,
                }
              : payload.actionToExecute;
        }

        // Map sequence object to sequenceId
        if (payload.sequence) {
          normalizedPayload.sequenceId =
            typeof payload.sequence === 'object'
              ? { label: payload.sequence.name, value: payload.sequence.id, ...payload.sequence }
              : payload.sequence;
        }

        // Map rpaAgent object to rpaAgentId
        if (payload.rpaAgent) {
          normalizedPayload.rpaAgentId =
            typeof payload.rpaAgent === 'object'
              ? { label: payload.rpaAgent.name, value: payload.rpaAgent.id, ...payload.rpaAgent }
              : payload.rpaAgent;
        }

        // Map rpaFlow object to rpaFlowId
        if (payload.rpaFlow) {
          normalizedPayload.rpaFlowId =
            typeof payload.rpaFlow === 'object'
              ? { label: payload.rpaFlow.name, value: payload.rpaFlow.id, ...payload.rpaFlow }
              : payload.rpaFlow;
        }

        // Map integration object to integrationId
        if (payload.integration) {
          normalizedPayload.integrationId =
            typeof payload.integration === 'object'
              ? {
                  label: payload.integration.name,
                  value: payload.integration.id,
                  ...payload.integration,
                }
              : payload.integration;
        }

        // Map integrationFunction object to integrationFunctionId
        if (payload.integrationFunction) {
          normalizedPayload.integrationFunctionId =
            typeof payload.integrationFunction === 'object'
              ? {
                  label: payload.integrationFunction.name,
                  value: payload.integrationFunction.id,
                  ...payload.integrationFunction,
                }
              : payload.integrationFunction;
        }

        // Note: dynamicEntity, operation, searchResultGroupingMode, searchResultAllocationMode, sortField, sortDirection, itemsAffected, customItemsAffectedNumber
        // are handled in the separate action-entity-operation component, not in the main config form

        // reason, logicalOperator, operationType, model, serviceType, sharePointOperation, ftpOperationType, programmingLanguage, whatsAppBusinessOperationType are mapped directly (no transformation needed)
      }

      return {
        ...state,
        configSelectedItem: normalizedPayload,
      };
    },

    addAction(state, { payload }) {
      return {
        ...state,
        newAction: payload.state,
        type: payload.type,
        defaultFieldsValue: payload.defaultFieldsValue,
      };
    },
    saveAction(state, { payload }) {
      return {
        ...state,
        saveAction: payload,
        newAction: false,
        success: true,
        selectedItem: null,
        tab: '',
      };
    },
    editAction(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        success: false,
      };
    },
    showConfigActions(state, { payload }) {
      return {
        ...state,
        showConfig: false, // Force false - BladeStack replaces drawer system
        id: payload.id,
        selectedItem: null,
      };
    },
    editOrViewAction(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    activeTabs(state, { payload }) {
      return {
        ...state,
        tab: payload,
      };
    },

    searchCriterias(state, { payload }) {
      return {
        ...state,
        listConfig: _.filter(state.listAll, (l) => {
          return (
            _.lowerCase(l.title).indexOf(_.lowerCase(payload)) > -1 ||
            _.lowerCase(l.description).indexOf(_.lowerCase(payload)) > -1
          );
        }),
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newCustomList: false,
        selectedItem: payload.item,
      };
    },

    saveSuccessPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newCustomList: false,
        successPermission: true,
      };
    },

    addInformation(state, { payload }) {
      return {
        ...state,
        success: true,
      };
    },

    queryInformation(state, { payload }) {
      return {
        ...state,
        dataInfomation: _.map(payload.data, (l) => {
          return {
            order: Number(l.order),
            fieldId: l.field.id,
            fieldBehavior: l.fieldBehavior,
            logicalOperator: l.logicalOperator,
          };
        }),
      };
    },
    queryCondiion(state, { payload }) {
      return {
        ...state,
        dataCondition: payload.data,
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        actionDataPermission: _.map(payload.data, (l) => {
          return {
            ...l,
          };
        }),
      };
    },

    updateNextActionIds(state, { payload, item, cords }) {
      return {
        ...state,
        list: _.map(state.list, (l) => {
          if (l.id === payload.item.id) {
            return {
              ...l,
              nextActionId: payload.nextActionId,
            };
          }
          return l;
        }),
      };
    },

    updateLocalPositions(state, { payload }) {
      // Update only the specific positions without affecting other actions
      const positionsMap = new Map(payload.map((pos) => [pos.id, pos]));

      const updatedList = state.list.map((item) => {
        const newPosition = positionsMap.get(item.id);
        if (newPosition) {
          return {
            ...item,
            x: newPosition.x,
            y: newPosition.y,
            diagramData: {
              ...item.diagramData,
              x: newPosition.x,
              y: newPosition.y,
            },
          };
        }
        return item;
      });

      return {
        ...state,
        list: updatedList,
      };
    },

    updateLocalNotePositions(state, { payload }) {
      // Update only the specific note positions
      const positionsMap = new Map(payload.map((pos) => [pos.id, pos]));

      const updatedNotes = state.notes.map((note) => {
        const newPosition = positionsMap.get(note.id);
        if (newPosition) {
          return {
            ...note,
            diagramData: {
              ...note.diagramData,
              x: newPosition.x,
              y: newPosition.y,
            },
          };
        }
        return note;
      });

      return {
        ...state,
        notes: updatedNotes,
      };
    },

    updateConnectionInList(state, { payload }) {
      // Update the entire list with the new connection data
      return {
        ...state,
        list: payload,
      };
    },

    addServerNoteToList(state, { payload }) {
      // Add the new note to the existing notes list
      const newNote = {
        id: payload.id,
        notes: payload.notes || '',
        diagramData: {
          x: payload.diagramData?.x || 0,
          y: payload.diagramData?.y || 0,
          w: payload.diagramData?.w || 200,
          h: payload.diagramData?.h || 200,
        },
      };

      // Add only the new note to the existing list
      return {
        ...state,
        notes: [...state.notes, newNote],
      };
    },

    updateNotesFromServer(state, { payload }) {
      // Update notes from server response
      const notesArray = payload?.notes || [];

      return {
        ...state,
        notes: notesArray,
      };
    },

    addServerActionToList(state, { payload }) {
      // Map server type string to enum (same logic as queryActionsFromDiagram)
      const typeMap = {
        'default-initial': CoreEnums.ActionType.DefaultInitial,
        'complete-information': CoreEnums.ActionType.CompleteInformation,
        approval: CoreEnums.ActionType.Approval,
        'auto-approve': CoreEnums.ActionType.AutoApprove,
        conditional: CoreEnums.ActionType.Conditional,
        'execute-task': CoreEnums.ActionType.ExecuteTask,
        'execute-api-call': CoreEnums.ActionType.ExecuteApiCall,
        'auto-reject': CoreEnums.ActionType.AutoReject,
        'digital-signature': CoreEnums.ActionType.DigitalSignature,
        'send-email': CoreEnums.ActionType.SendEmail,
        'execute-query': CoreEnums.ActionType.ExecuteQuery,
        'dynamic-entity-operation': CoreEnums.ActionType.DynamicEntityOperation,
        'generate-excel': CoreEnums.ActionType.GenerateExcel,
        'start-process-instance': CoreEnums.ActionType.StartProcessInstance,
        'set-variable': CoreEnums.ActionType.SetVariableData,
        'set-form-data': CoreEnums.ActionType.SetFormData,
        parallel: CoreEnums.ActionType.Parallel,
        'generate-documents': CoreEnums.ActionType.GenerateDocuments,
        'scheduled-execution': CoreEnums.ActionType.ScheduledExecution,
        'sharepoint-operation': CoreEnums.ActionType.SharePointOperation,
        iterate: CoreEnums.ActionType.Iterate,
        switch: CoreEnums.ActionType.Switch,
        'internal-operation': CoreEnums.ActionType.InternalOperation,
        'generate-plain-text-file': CoreEnums.ActionType.GeneratePlainTextFile,
        'import-plain-text-file': CoreEnums.ActionType.ImportPlainTextFile,
        'consume-sequence': CoreEnums.ActionType.ConsumeSequence,
        'execute-rpa-flow': CoreEnums.ActionType.ExecuteRpaFlow,
        integration: CoreEnums.ActionType.Integration,
        'auto-cancel': CoreEnums.ActionType.AutoCancel,
        'auto-void': CoreEnums.ActionType.AutoVoid,
        openai: CoreEnums.ActionType.OpenAI,
        'automy-ai': CoreEnums.ActionType.AutomyAI,
        'execute-process-action': CoreEnums.ActionType.ExecuteProcessAction,
        'google-integration': CoreEnums.ActionType.GoogleIntegration,
        'revert-cancellation': CoreEnums.ActionType.RevertCancellation,
        'revert-voiding': CoreEnums.ActionType.RevertVoiding,
        'ftp-operation': CoreEnums.ActionType.FTPOperation,
        'run-code': CoreEnums.ActionType.RunCode,
        'whatsapp-business-integration': CoreEnums.ActionType.WhatsAppBusinessIntegration,
      };

      const mappedType = typeMap[payload.type] ?? CoreEnums.ActionType.CompleteInformation;
      const x = payload.diagramData?.x || 0;
      const y = payload.diagramData?.y || 0;

      const newAction = {
        ...payload,
        type: mappedType,
        displayTitle: payload.name || payload.description || 'Sin nombre',
        diagramData: { x, y },
        nextActionId: payload.nextAction?.id,
        nextActionIfFalseId: payload.nextActionIfFalse?.id,
        isDefaultInternalInitialCompleteInformationAction: payload.type === 'default-initial',
        isInitialAction: payload.type === 'default-initial',
        fromServer: true,
        isTemporary: false,
      };

      // Add only the new action to the existing list
      return {
        ...state,
        list: [...state.list, newAction],
      };
    },

    removeActionFromList(state, { payload }) {
      const { actionId } = payload;

      // Remove the action from the list
      const updatedList = state.list.filter((item) => item.id !== actionId);

      return {
        ...state,
        list: updatedList,
      };
    },

    removeNoteFromList(state, { payload }) {
      const { noteId } = payload;

      // Optimistically remove the note from the notes array
      const updatedNotes = state.notes.filter((note) => note.id !== noteId);

      return {
        ...state,
        notes: updatedNotes,
      };
    },

    hideActions(state) {
      return {
        ...state,
        newAction: false,
        list: [],
        listAll: [],
        listAllConfig: [],
        view: null,
        id: null,
        dataInfomation: null,
        success: false,
      };
    },
    clearSelectedItems(state) {
      return {
        ...state,
        configSelectedItem: null,
        success: false,
        tab: 'configurations', // Reset to default tab when clearing selected item
      };
    },
    hidePermission(state) {
      return {
        ...state,
        listDataPermission: null,
        successPermission: false,
      };
    },

    addState(state, { payload }) {
      const newState = { ...state };
      if (state.currentIndex < state.history.length - 1) {
        newState.history = newState.history.slice(0, state.currentIndex + 1);
      }
      newState.history.push(payload);
      newState.currentIndex++;
      return newState;
    },

    undo(state) {
      if (state.currentIndex > 0) {
        const newIndex = state.currentIndex - 1;
        const currentState = state.history[newIndex];
        return { ...state, currentIndex: newIndex, currentState };
      }
      return state;
    },
    redo(state) {
      if (state.currentIndex < state.history.length - 1) {
        const newIndex = state.currentIndex + 1;
        const currentState = state.history[newIndex];
        return { ...state, currentIndex: newIndex, currentState };
      }
      return state;
    },
    saveState(state) {
      return { ...state, latestSaveIndex: state.currentIndex };
    },

    resetState() {
      return initialState;
    },
  },
};

export default Model;
